import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const EmployeeLeaveStatus: GenericStatus[] = [
    {key: "requested", text: "Requested", tagVariant: 'default'},
    {key: "confirmed", text: "Confirmed", tagVariant: 'active'},
    {key: "approved", text: "Approved", tagVariant: 'success'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]

export default EmployeeLeaveStatus;